import React from "react"
import Hotspot from './Hotspot'
import {useStore} from "../store"
import scenes from "../scenes"
import {HotspotActions} from '../constants'


function Hotspots() {
	//const [myVal, setValue] = useState("Anfangswert")
	const setScene = useStore(state => state.setScene)
	const currentScene = useStore(state => state.currentScene)
	const hotspotsData = scenes[currentScene].hotspots
	const setCurrentAsset = useStore(state => state.setCurrentAsset)
	const setAssetModalOpen = useStore(state => state.setAssetModalOpen)
	
	return (
		hotspotsData.map((data) => {
			let action = null
			switch(data.action) {
				case HotspotActions.setScene:
					action = () => setScene(data.target)
					break
				case HotspotActions.showAsset:
					action = () => {
						setCurrentAsset(data.target)
						setAssetModalOpen(true)
					}
					break
				default:
					action = () => console.log("Hotspot without action")
			}
			const infoText = data.infoText ? data.infoText : null
			return (
				<Hotspot position={data.position} onClick={action} color='lightblue' icon={data.icon} key={data.target} doPulsing={data.doPulsing===true} infoText={infoText} />
			)
		})
	)
}

export default Hotspots
